<!-- src/admin/components/AdminLayout.vue -->
<template>
  <div class="flex h-screen">
    <!-- Sidebar -->
    <aside class="w-64 bg-[#25006b] text-white p-6">
      <h2 class="text-xl font-bold mb-6">SITE INTEGRATOR</h2>
      <ul class="space-y-2">
        <li><RouterLink to="/integratoradm/dashboard" class="block hover:text-pink-400">Home</RouterLink></li>
        <li><RouterLink to="/integratoradm/banner" class="block hover:text-pink-400">Banners</RouterLink></li>
        <li><RouterLink to="/integratoradm/bannericp" class="block hover:text-pink-400">Banners ICP</RouterLink></li>
        <li><RouterLink to="/integratoradm/destaques" class="block hover:text-pink-400">Destaques Home</RouterLink></li>
        <li><RouterLink to="/integratoradm/planos" class="block hover:text-pink-400">Planos</RouterLink></li>
        <li><RouterLink to="/integratoradm/cupons" class="block hover:text-pink-400">Cupons</RouterLink></li>
        <li>
          <button
            @click="logout"
            class="w-full text-left text-red-400 hover:text-red-600 mt-4"
          >
            Sair
          </button>
        </li>
      </ul>
    </aside>

    <!-- Conteúdo -->
    <main class="flex-1 bg-gray-100 p-6 overflow-auto">
      <RouterView />
    </main>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const logout = async () => {
  await fetch('http://localhost:8080/auth/logout', {
    method: 'POST',
    credentials: 'include'
  })
  router.push('/integratoradm/login')
}
</script>
